// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2ltAe","overflowing":"ReadFullNote_overflowing__uLXPi"};